import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tableContainer", "tableHeader", "tableRow"]

  connect() {
    if (this.tableRowTargets.length > 5) {
      this.tableContainerTarget.style.height = `${(this.tableRowTargets[0].offsetHeight * Math.max(6, this.tableRowTargets.length / 2)) + this.tableHeaderTarget.offsetHeight}px`;
    }
  }
}
